/**
 * True when the technician works on the given day.
 *
 * JS `getDay()` returns 0=Sun,1=Mon..6=Sat; the DB stores `workingDays`
 * as 1=Mon..7=Sun, so Sunday has to be remapped.
 */
export function isWorkingDay(workingDays: number[], dayIso: string): boolean {
  const dow = new Date(dayIso).getDay()
  const mapped = dow === 0 ? 7 : dow
  return workingDays.includes(mapped)
}
